module.exports = __webpack_public_path__ + "img/20210906-1630910921931768.dfb78332.jpg";